<script setup lang="ts">
import { computed } from 'vue'

import AppButton from 'primevue/button'
import { useThemeStore } from '@/stores/useThemeStore'
import { useI18n } from 'vue-i18n'

const themeStore = useThemeStore()
const { t } = useI18n()

const buttonIcon = computed(() => (themeStore.isDark ? 'pi pi-sun' : 'pi pi-moon'))
const buttonSeverity = computed(() => (themeStore.isDark ? 'primary' : 'secondary'))
const tooltipText = computed(() =>
  t(themeStore.isDark ? 'sidebar.menu.lightMode' : 'sidebar.menu.darkMode'),
)

function toggleTheme() {
  themeStore.toggleDark()
}
</script>

<template>
  <div>
    <AppButton
      size="small"
      outlined
      :severity="buttonSeverity"
      variant="outlined"
      :icon="buttonIcon"
      v-tooltip.bottom="tooltipText"
      @click="toggleTheme"
      class="app-button-header-glass shadow-md min-w-9 hover:bg-white/50! dark:hover:bg-[var(--p-primary-600)]/50! dark:text-[var(--p-primary-50)]/90! dark:border-[var(--p-primary-50)]/90! !w-9 !h-9 flex items-center justify-center transition-all duration-200 hover:scale-105 active:scale-95 !rounded-xl"
    />
  </div>
</template>
